import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Bubble, Button, Form, Modal } from 'tea-component';
import BubbleCommon, {
  summaryOptionalKeywords,
  summaryRequiredKeywords,
  summaryRequiredKeywordsTitleTips,
} from '@op/components/BubbleCommon';
import { getTopicKeywords } from '@op/services/summary';
import Tips from '@op/components/Snippets/Tips';
import './index.scss';
import { useIntl } from 'umi';
import { dealwithKeywordStr } from '@op/pages/Summary/utils';
import { FilterContext } from '../../context';
export default function KeywordsModal({
  visible,
  close,
  tier2Topic,
  propsTransTopic,
  propsGameInfo,
  useLocale,
  localData,
}: any) {
  const { transTopic: contextTransTopic, gameInfo: contextGameInfo } =
    useContext(FilterContext);

  const [transTopic, gameInfo] = useMemo(() => {
    if (useLocale) return [propsTransTopic, propsGameInfo];

    return [contextTransTopic, contextGameInfo];
  }, [propsTransTopic, propsGameInfo, contextTransTopic, contextGameInfo]);

  const [requiredKeywords, setRequiredKeywords] = useState([]);

  const [optionalKeywords, setOptionalKeywords] = useState([]);
  const [tier1TopicText, setTier1TopicText] = useState('');
  const [tier2TopicText, setTier2TopicText] = useState('');

  const renderRequiredKeywordElement = useCallback(
    (keywordInfo: any[], noWrap?: boolean) => {
      if (!keywordInfo || keywordInfo?.length === 0)
        return <span className="keyword-item">-</span>;
      return keywordInfo?.map((item: any, i) => {
        let { keyword } = item;
        let result: Array<any> = dealwithKeywordStr(item, (region, item) => (
          <p key={region + item} className="keyword-item">
            <span className="language-info">{region}</span>
            <span className="keyword-value">{item}</span>
          </p>
        ));

        let elementItem = result.map((item, index) => (
          <Bubble
            dark
            closeOnScroll
            key={item + index}
            // trigger={'click'}
            placementOffset={[0, 0]}
            content={<div className="keyword-list-box">{item.content}</div>}
          >
            <span className="keyword-item">{item.origin}</span>
            {result.length !== index + 1 ? ', ' : ''}
          </Bubble>
        ));

        if (noWrap) {
          return (
            <Fragment key={keyword}>
              {elementItem}
              {keywordInfo.length !== i + 1 ? ', ' : ''}
            </Fragment>
          );
        }
        return <Form.Text key={keyword}>{elementItem}</Form.Text>;
      });
    },
    [],
  );

  let [loading, setLoading] = useState(false);
  let [apiError, setApiError] = useState(false);

  function setDataInfo(data: any) {
    let { must_list, candidate_list, l1_topic, l2_topic } = data || {};
    setRequiredKeywords(must_list || []);
    setOptionalKeywords(candidate_list || []);
    setTier1TopicText((l1_topic || '').toLocaleLowerCase());
    setTier2TopicText((l2_topic || '').toLocaleLowerCase());
    setLoading(false);
  }

  useEffect(() => {
    if (tier2Topic) {
      setLoading(true);
      setApiError(false);
      if (localData) {
        setDataInfo(localData);
      } else {
        getTopicKeywords({ ...gameInfo, l2_topic: tier2Topic }).then(
          (data: any) => {
            setDataInfo(data);
          },
        );
      }
    }
  }, [gameInfo, tier2Topic, localData]);

  const { formatMessage } = useIntl();

  return (
    <Modal
      className="dbo-keywords-modal-wrapper"
      visible={visible}
      size="m"
      caption={
        <div className="dbo-wrapper-title">
          {formatMessage({ id: 'Topic Definition' })}
          <BubbleCommon
            placement="top"
            tipsMap={summaryRequiredKeywordsTitleTips}
          ></BubbleCommon>
        </div>
      }
      onClose={close}
    >
      <Modal.Body>
        <Tips
          loading={loading}
          apiError={apiError}
          className={`${loading || apiError ? 'tips' : ''}`}
        >
          <>
            <Form fixedLabelWidth={115} readonly className="form-box">
              <Form.Item
                label={formatMessage({ id: 'Tier 1 Topic' })}
                className="form-item"
              >
                <Form.Text>{transTopic(tier1TopicText, 'L1')}</Form.Text>
              </Form.Item>
              <Form.Item
                label={formatMessage({ id: 'Tier 2 Topic' })}
                className="form-item"
              >
                <Form.Text>{transTopic(tier2TopicText, 'L2')}</Form.Text>
              </Form.Item>
              <Form.Item
                label={
                  <div className="dbo-wrapper-title">
                    {formatMessage({ id: 'Must Have Keywords' })}
                    <BubbleCommon
                      placement="top"
                      tipsMap={summaryRequiredKeywords}
                    ></BubbleCommon>
                  </div>
                }
                className="form-item"
              >
                {renderRequiredKeywordElement(requiredKeywords)}
              </Form.Item>
              <Form.Item
                label={
                  <div className="dbo-wrapper-title">
                    {formatMessage({ id: 'Optional keywords' })}
                    <BubbleCommon
                      placement="top"
                      tipsMap={summaryOptionalKeywords}
                    ></BubbleCommon>
                  </div>
                }
                className="form-item"
              >
                <Form.Text>
                  {renderRequiredKeywordElement(optionalKeywords, true)}
                </Form.Text>
              </Form.Item>
            </Form>
            <Form.Action>
              <Button type="primary" onClick={close}>
                {formatMessage({ id: 'Confirm' })}
              </Button>
            </Form.Action>
          </>
        </Tips>
      </Modal.Body>
    </Modal>
  );
}
